import { createSlice } from '@reduxjs/toolkit';

interface AllUsersState {
  users: any[];
}

const initialState: AllUsersState = {
  users: [],
};

const allUsersSlice = createSlice({
  name: 'allUsers',
  initialState,
  reducers: {
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    addUser: (state, action) => {
      state.users.push(action.payload);
    },
    addUsersBulk: (state, action) => {
      state.users = [...state.users, ...action.payload];
    },
    removeUser: (state, action) => {
      state.users = state.users.filter((user) => user.id !== action.payload);
    },
    updateUser: (state, action) => {
      const index = state.users.findIndex((u) => u.id === action.payload.id);
      if (index !== -1) {
        state.users[index] = { ...state.users[index], ...action.payload };
      }
    },
  },
});

export const { setUsers, addUser, addUsersBulk, removeUser, updateUser } =
  allUsersSlice.actions;

export default allUsersSlice.reducer;
